import { Row } from "react-bootstrap";
import "./style.scss";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function CardArea({
  children,alignItems,justifyContent
}:{
  children:any|any[];
  alignItems?:"start"|"center"|"end";
  justifyContent?:"start"|"center"|"end"|"around"|"between"
}){

  let className = "my-area-card";
  if(alignItems) className+=" align-items"+alignItems;
  if(justifyContent) className+=" justify-content"+justifyContent;

  return (
    <Row className={className}>
      {children}
    </Row>
  );
}